import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { TextField, Button, Typography, Paper} from '@material-ui/core';
import FileBase from 'react-file-base64';
import { useDispatch, useSelector } from 'react-redux';
import { createPost, updatePost } from '../../actions/posts';

const useStyles = makeStyles((theme) => ({
    root: {
      '& .MuiTextField-root': {
        margin: theme.spacing(1),
      },
    },
    paper: {
      padding: theme.spacing(2),
    },
    form: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'center',
    },
    fileInput: {
      width: '97%',
      margin: '10px 0',
    },
    buttonSubmit: {
      marginBottom: 10,
    },
  }));

export default function Form({ currentId, setCurrentId }) {

    const classes = useStyles();
    const dispatch= useDispatch();
    const post = useSelector(state => currentId ? state.posts.find((p) => p._id === currentId) : null);

    const [ postData, setPostData ] = useState({
      creator: '',
      title: "",
      message: "",
      tags: "",
      selectedFile: ""
    });

    useEffect(() => {
      if(post) {
        setPostData(post)
      }
    }, [post])

    const handleSubmit = (e) => {
      e.preventDefault();

      if(currentId){
        dispatch(updatePost(currentId, postData));
      } else {
        dispatch(createPost(postData)); 
      } 
      clear(); 
    }

    const clear = () => {
      setCurrentId(null);
      setPostData({ creator: '', title: "", message: "", tags: "", selectedFile: "" })
    }

    return (
        <Paper className={classes.paper}>
          <form autoComplete="off" noValidate className={`${classes.root} ${classes.form}`} onSubmit={handleSubmit}>
            <Typography variant="h6">{currentId ? `Editing` : `Creating`} a Memory</Typography>
            <TextField 
              name="creator" 
              variant="outlined" 
              label="Creator" 
              fullWidth 
              value={postData.creator}
              onChange={(e) => setPostData({ ...postData, "creator": e.target.value})}
            />
            <TextField 
              name="title" 
              variant="outlined" 
              label="Title" 
              fullWidth 
              value={postData.title}
              onChange={(e) => setPostData({ ...postData, "title": e.target.value})}
            />
            <TextField 
              name="message" 
              variant="outlined" 
              label="Message" 
              fullWidth 
              value={postData.message}
              onChange={(e) => setPostData({ ...postData, "message": e.target.value})}
            />
            <TextField 
              name="tags" 
              variant="outlined" 
              label="Tags" 
              fullWidth 
              value={postData.tags}
              onChange={(e) => setPostData({ ...postData, "tags": e.target.value.split(',')})}
            />
            <div className={classes.fileInput}><FileBase type="file" multiple={false} onDone={({ base64 }) => setPostData({ ...postData, selectedFile: base64 })} /></div>
            <Button 
              className={classes.buttonSubmit} 
              variant="contained" 
              color="primary" 
              size="large" 
              type="submit" 
              fullWidth
            >
              Submit
            </Button>
            <Button 
              variant="contained" 
              color="secondary" 
              size="small" 
              fullWidth
              onClick={clear}
            >
              Clear
            </Button>
          </form>
        </Paper>
    )
}
